import styled from 'styled-components'

import { login } from '../../styles/z-index'
import { minmedia, maxmedia } from '../../styles/media-queries'
import { black } from '../../styles/colors'

export const Container = styled.section`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 2rem 0;
  overflow: hidden; /*IE11*/

  background-image: url(${props => props.mobile});
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;

  ${maxmedia.large`
    background-attachment: fixed;
  `};

  @media screen and (min-width: 751px) {
    background-image: url(${props => props.image});
  }

  &::before {
    content: '';
    transition: all 0.5s;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: ${black};
    z-index: 0;
    opacity: ${props => (props.overlay ? '0.5' : '0')};

    ${maxmedia.large`
      opacity: 0.5;
    `}
  }
`

export const Logo = styled.img`
  position: relative;
  z-index: ${login};
  width: 89px;
  height: 100px;
  margin-top: 1rem;
  margin-bottom: 2rem;

  ${minmedia.medium`
    width: 143px;
    height: 161px;
    margin-top: 3rem;
    margin-bottom: 3rem;
  `}
  ${minmedia.large`
    width: 178px;
    height: 200px;
    margin-top: 1rem;
    margin-bottom: 2rem;
  `}
  ${minmedia.xxlarge`
    margin-top: 2rem;
    margin-bottom: 3rem;
  `}
  @media screen and (min-width: 1920px) {
    margin-bottom: 4rem;
  }
`

export const BranchesContainer = styled.div`
  width: calc(100% - 4rem);
  max-width: 1100px;
`



// WEBPACK FOOTER //
// ./src/views/AFAS/styles.js